export const policies = {
  title: "Políticas",
  new: "Nueva política",
  detail: "Política",
  list: {
    description:
      "Quién puede usar qué certificados y dónde. Sin una política que lo permita, no se usa ningún certificado.",
    search: "Buscar por nombre o persona",
    certificateFilter: "Certificado",
    allCertificates: "Todos los certificados",
    stateFilter: "Estado",
    allStates: "Todos los estados",
    states: {
      enabled: "Activa",
      disabled: "Desactivada",
      expired: "Fuera de vigencia",
    },
    emptyTitle: "Todavía no hay políticas",
    emptyDescription:
      "Crea una para decir quién puede usar cada certificado y en qué sedes.",
    columns: {
      name: "Nombre",
      who: "Quién",
      certificates: "Certificados",
      rules: "Reglas",
      validity: "Vigencia",
      state: "Estado",
    },
    groupLabel: "grupo {{name}}",
    nobody: "Nadie todavía",
    denyCount_one: "{{count}} de denegar",
    denyCount_other: "{{count}} de denegar",
  },
  editor: {
    notFound: "Esta política no existe o ya se ha borrado.",
    saved: "Política guardada",
    deleted: "Política borrada",
    untitled: "Sin nombre",
    history: "Historial",
    conflictTitle: "Otra persona ha cambiado esta política",
    conflictDescription:
      "Mientras la editabas, otro administrador guardó cambios. Recarga para ver la versión actual (perderás lo que no hayas guardado).",
    reload: "Recargar",
    serverRejected: "El servidor no ha aceptado la política",
    deleteTitle: "¿Borrar «{{name}}»?",
    deleteDescription:
      "Las personas que tenían acceso por esta política lo pierden al momento. El registro de cambios se conserva.",
    deleteConfirm: "Borrar política",
    unsavedTitle: "Tienes cambios sin guardar",
    unsavedDescription: "Si sales ahora, se pierden.",
    leave: "Salir sin guardar",
    name: "Nombre",
    namePlaceholder: "Por ejemplo, AEAT sin renta",
    description: "Descripción",
    descriptionPlaceholder: "Para qué es esta política (opcional)",
    who: "Quién",
    groupChip: "Grupo {{name}} ({{count}})",
    suspendedUser: "Suspendida: no puede usar nada mientras lo esté.",
    searchWho: "Buscar personas o grupos",
    groups: "Grupos",
    people: "Personas",
    noSubjects:
      "Nadie todavía: añade personas o grupos para que la política se aplique.",
    withCredentials: "Con qué certificados",
    searchCredentials: "Buscar certificados",
    where: "Dónde",
    denyWins: "Las reglas de denegar ganan siempre, estén donde estén.",
    noRules:
      "Sin reglas, la política no permite nada. Añade una regla de permitir.",
    rulesLabel: "Reglas",
    editRule: "Editar la regla {{number}}",
    moveUp: "Subir la regla {{number}}",
    moveDown: "Bajar la regla {{number}}",
    ruleMenu: "Más acciones de la regla {{number}}",
    duplicate: "Duplicar",
    cannotSave: "Para poder guardar:",
  },
  issues: {
    nameRequired: "Ponle un nombre a la política.",
    credentialsRequired: "Añade al menos un certificado.",
    noRules: "Añade al menos una regla.",
    ruleUsesRequired: "Regla {{number}}: elige al menos un uso.",
    ruleDomainsRequired: "Regla {{number}}: añade al menos un dominio.",
    required: "Falta un dato obligatorio.",
    invalidDomain: "Regla {{number}}: «{{domain}}» no es un dominio válido.",
    unknownGroup:
      "Regla {{number}}: el grupo «{{domain}}» no existe en el catálogo.",
    outsideCatalog:
      "Regla {{number}}: «{{domain}}» está fuera del catálogo de sedes.",
    invalidPath:
      "Regla {{number}}: la ruta {{path}} no es una expresión válida.",
    invalidMethod: "Regla {{number}}: hay un método HTTP no válido.",
    invalidApp:
      "Regla {{number}}: en firma de documentos, cada app tiene que ser un origen (https://…) o un dominio.",
    invalidDate: "Hay una fecha de vigencia no válida.",
    invalidValidity: "La fecha de fin tiene que ser posterior a la de inicio.",
    invalidLimit: "Los límites tienen que ser números enteros positivos.",
    invalidFormat: "Hay un formato de firma vacío.",
    invalidRule: "Regla {{number}}: no es válida.",
    pathsUnused: "Regla {{number}}: las rutas solo se aplican en navegación.",
    pathsProxyOnly:
      "Regla {{number}}: las rutas solo se aplican con la app de Mac abierta.",
    appsInformational:
      "Regla {{number}}: en login y navegación las apps solo informan.",
    methodsUnused:
      "Regla {{number}}: los métodos solo se aplican en navegación.",
  },
  domainProblems: {
    invalid:
      "«{{domain}}» no es un dominio válido: escribe x.y, *.x.y o @grupo.",
    "unknown-group": "El grupo «{{domain}}» no existe en el catálogo.",
    "outside-catalog":
      "«{{domain}}» no está en el catálogo de webs (versión {{version}}) y no se puede guardar: la CA del proxy de cada Mac solo cubre el catálogo. Pide a un administrador de Punto.Firma que lo añada; después cada Mac lo recibe con «Actualizar webs permitidas».",
  },
  outsideCatalogPlatform:
    "«{{domain}}» no está en el catálogo de webs (versión {{version}}). Añádelo al catálogo y publícalo; después ya se puede guardar en la política.",
  addToCatalog: "Añadir al catálogo de webs",
  rulePanel: {
    title: "Regla {{number}}",
    description:
      "Los cambios se ven al momento en el probador. Se guardan con la política.",
    revert: "Deshacer cambios",
    done: "Hecho",
    effect: "Efecto",
    denyWins: "Una regla de denegar gana a cualquier regla de permitir.",
    targets: "Dominios y rutas",
    targetsHint:
      "Un dominio entero (cubre sus subdominios; *.dominio, solo los subdominios; @grupo, todas las sedes del grupo) o una ruta: sede.ejemplo.gob.es/ruta, que cubre todo lo que cuelga de ella.",
    allDomains: "Todos",
    addTarget: "Añadir dominio o ruta",
    searchCatalog: "Buscar en el catálogo o escribir un dominio o ruta",
    noCatalogMatch: "Nada en el catálogo con ese texto.",
    catalogGroups: "Grupos del catálogo",
    catalogDomains: "Dominios del catálogo",
    addTyped: "Añadir «{{domain}}»",
    domainsRequired: "Añade al menos un dominio o una ruta, o marca «Todos».",
    wholeDomainNeedsRule:
      "Esta regla es de rutas: para un dominio entero, añade otra regla.",
    pathNeedsRule:
      "Las rutas de una regla son de un solo dominio y no se mezclan con dominios enteros: para esta ruta, añade otra regla.",
    pathsProxyOnly:
      "Las reglas por ruta solo se aplican mientras la app de Mac está abierta: con la app cerrada, el navegador puede abrir la ruta con la sesión que ya tiene.",
    ruleDescription: "Descripción (opcional)",
    ruleDescriptionPlaceholder: "Por ejemplo, Renta",
  },
  options: {
    title: "Opciones",
    show: "Cambiar",
    hide: "Ocultar",
    validity: "Vigencia",
    enabled: "Política activa",
    validFrom: "Desde",
    validUntil: "Hasta",
    errors: {
      order: "La fecha de fin tiene que ser posterior a la de inicio.",
    },
    summary: {
      always: "siempre",
      between: "del {{from}} al {{until}}",
      from: "desde el {{from}}",
      until: "hasta el {{until}}",
      disabled: "desactivada",
    },
  },
  history: {
    title: "Historial de cambios",
    description:
      "Quién cambió esta política, cuándo, y cómo era antes y después.",
    empty: "Sin cambios registrados.",
    revision: "revisión {{revision}}",
    system: "Sistema",
    before: "Antes",
    after: "Después",
    actions: {
      created: "Creada",
      updated: "Cambiada",
      deleted: "Borrada",
    },
  },
  tester: {
    title: "Probar",
    description:
      "Con el mismo evaluador que la app y el servidor, y con los cambios sin guardar.",
    person: "Persona",
    choosePerson: "Elige una persona",
    certificate: "Certificado",
    chooseCertificate: "Elige un certificado",
    use: "Uso",
    method: "Método",
    url: "URL",
    uses: {
      navigation: "Abrir una página",
      document: "Firmar un documento (afirma://)",
    },
    sede: "Sede (servidor de firma)",
    origin: "Origen de la web",
    originHint:
      "La web que pide la firma. Si se indica, también tiene que estar en los dominios de la regla, no solo la sede.",
    fillIn: "Elige persona y certificado y escribe una URL.",
    invalidUrl: "La URL no es válida.",
    normalizedPath: "Ruta comparada:",
    checking: "Comprobando…",
    checkServer: "Comprobar en el servidor",
    serverIssues: "Reglas del borrador que el servidor no ha tenido en cuenta:",
    serverAgrees: "El servidor dice lo mismo ({{reason}}).",
    serverDiffers:
      "El servidor dice otra cosa: {{decision}} ({{reason}}). Puede que haya cambios en otras políticas o en la persona que aquí no se ven todavía.",
    recent: "URLs recientes de este dominio",
    noRecent: "No hay navegación registrada en este dominio.",
    defaultDeny: "Ninguna regla lo permite: denegado por defecto",
    ruleOfThis: "Regla {{number}} de esta política",
    ruleOfOther: "Regla {{number}} de «{{policy}}»",
    decision: {
      allow: "Permitido",
      deny: "Denegado",
    },
    notes: {
      invalidHost: "El dominio de la URL no es válido.",
      appsInformational:
        "Hay reglas con apps en login o navegación: de momento solo informan.",
      invalidPath:
        "Alguna expresión de ruta no es válida: se aplica fallo cerrado.",
      originOutside:
        "La web que pide la firma (origen) no está en los dominios de alguna regla que permite la sede.",
      loginByDomain:
        "El login se decide por dominio; las reglas de denegar con rutas se aplican después, en cada página.",
      notApplicable: {
        subject: "Esta política no se aplica a esta persona.",
        credential: "Esta política no incluye este certificado.",
        validity: "Esta política no está en vigor ahora.",
        format: "Esta política no admite este formato de firma.",
      },
    },
  },
  evaluateReasons: {
    "deny-rule": "lo deniega una regla",
    "allow-rule": "lo permite una regla",
    "default-deny": "ninguna regla lo permite",
    "invalid-host": "el dominio no es válido",
  },
};
